import { validateRadioInputChoices } from "../../../../Forms/components/Question/Inputs/Radio";
import {
  SUPPORTED_INPUT_TYPES as TYPES,
  ADDRESS_SUB_TYPE_VALUES,
} from "../../../../Forms/util/constants";

const normalizer = (entity) => {
  let reshapedEntity = {};
  if (!entity?.dataType || !entity?.id) {
    return null;
  }
  const DATATYPE = entity.dataType.toUpperCase();
  if(!Object.values(TYPES).includes(DATATYPE)) {
    return null;
  }
  const {
    id,
    required,
    title,
    helperText,
    validationText,
    description,
    defaultValue,
    dataField,
    include = [],
    startAdornment,
    endAdornment,
    groupId,
    groupMinimumRequired,
  } = entity;
  if (!dataField) {
    return null;
  }

  reshapedEntity = {
    label: '',
    helperText: validationText,
    modal: helperText,
    description: '',
    defaultValue,
    name: dataField,
  };

  if(title && description) {
    reshapedEntity.label = title;
    reshapedEntity.description = description;
  } else if(title) {
    reshapedEntity.label = title;
  } else if(description) {
    reshapedEntity.label = description;
  }

  if (startAdornment || endAdornment) {
    reshapedEntity.startAdornment = startAdornment;
    reshapedEntity.endAdornment = endAdornment;
  }
  if (DATATYPE === TYPES.address) {
    reshapedEntity.include = [];
    include.forEach((txt) => {
      const normalized = Object.values(ADDRESS_SUB_TYPE_VALUES).find(
        (v) => v.toUpperCase() === (txt || "").toUpperCase()
      );
      if (normalized) {
        reshapedEntity.include.push(normalized);
      }
    });
  }
  if ([TYPES.numeric, TYPES.decimal, TYPES.currency].includes(DATATYPE)) {
    const isCurrency = TYPES.currency === DATATYPE;
    reshapedEntity.type = "number";
    reshapedEntity.inputMode =
      TYPES.numeric === DATATYPE
        ? "numeric"
        : TYPES.decimal === DATATYPE || isCurrency
          ? "decimal"
          : undefined;
    reshapedEntity.min = entity.min;
    reshapedEntity.max = entity.max;
    if(entity.round) {
      reshapedEntity.step = entity.step || 1;
      reshapedEntity.round = true
    } else {
      reshapedEntity.step = entity.step;
    }
    if (isCurrency) {
      reshapedEntity.startAdornment = startAdornment || "$";
    }
  }

  if(DATATYPE === TYPES.radio) {
    let _choices = validateRadioInputChoices(entity.choices);
    _choices = _choices.map(({ value, relatedQuestions: _relatedQuestions = [], ...rest }) => {
      const val = value === true ? "true" : value === false ? "false" : value
      const relatedQuestions = (_relatedQuestions || []).map(q => ({
        compact: true,
        ...normalizer(q)
      }))
      let relatedQuestionsLegend = entity.relatedQuestionsLegend || ``
      if(!relatedQuestionsLegend && relatedQuestions?.length) {
        relatedQuestionsLegend = `Related Questions`
      }
      return {
        ...rest,
        value: val,
        relatedQuestions,
        relatedQuestionsLegend
      }
    })
    if(!_choices?.length) {
      return null
    }
    reshapedEntity.choices = _choices
  }

  if(DATATYPE === TYPES.textArea) {
    reshapedEntity.multiline = entity.multiline ?? true
    const { minRows, maxRows, rows } = entity 
    if(rows) {
      reshapedEntity.rows = rows
    } else if (minRows || maxRows) {
      reshapedEntity.minRows = minRows
      reshapedEntity.maxRows = maxRows
    } else {
      reshapedEntity.rows = 3
    }
  }
  
  return {
    dataType: DATATYPE,
    id,
    required,
    groupId,
    groupMinimumRequired,
    ...reshapedEntity,
  };
};

export default normalizer;
